import { FC, memo } from 'react'

/**
 * ローディングエフェクト
 */
// devextremeのLoadIndicatorは単にアニメーション画像を表示するだけでカスタム性が無かったため独自実装
export const CrewLoadingEffect: FC = memo(() => (
  <div className="w-full h-full animate-pulse bg-crew-sky-blue-4-light dark:bg-crew-sky-blue-1-dark" />
))
